import handleFormatPrice from "./handleFormatPrice";

export default function getSolvencyDisplay(solvency, date) {
    if (+solvency === 0) return "Keine Bonitätsauskunft verfügbar";
    else return handleFormatPrice(solvency, 1, "") + " (unverbindliche Angabe gemäß Creditsafe vom " + date + ")";
}
